export const GET_LOCATION_AMENITIES_REQUEST = "GET_LOCATION_AMENITIES_REQUEST";
export const GET_LOCATION_AMENITIES_SUCCESS = "GET_LOCATION_AMENITIES_SUCCESS";
export const GET_LOCATION_AMENITIES_FAILURE = "GET_LOCATION_AMENITIES_FAILURE";

export const CLEAR_LOCATION_AMENITIES = "CLEAR_LOCATION_AMENITIES"
